import type { Stage } from "./types";
import stageData from "../data/stages.json";

export const STAGES: readonly Stage[] = stageData as Stage[];

const BY_ID = new Map<string, Stage>(STAGES.map((s) => [s.id, s]));

export function getStage(id: string): Stage | undefined {
  return BY_ID.get(id);
}

/** Stages grouped by world → chapter, ordered. */
export interface ChapterGroup {
  world: number;
  chapter: number;
  stages: Stage[];
}

export function chapters(): ChapterGroup[] {
  const map = new Map<string, ChapterGroup>();
  for (const s of STAGES) {
    const key = `${s.world}-${s.chapter}`;
    let g = map.get(key);
    if (!g) {
      g = { world: s.world, chapter: s.chapter, stages: [] };
      map.set(key, g);
    }
    g.stages.push(s);
  }
  for (const g of map.values()) g.stages.sort((a, b) => a.order - b.order);
  return [...map.values()].sort((a, b) => a.world - b.world || a.chapter - b.chapter);
}

/** All stages in canonical play order (world → chapter → order). */
export const ORDERED_STAGES: readonly Stage[] = [...STAGES].sort(
  (a, b) => a.world - b.world || a.chapter - b.chapter || a.order - b.order,
);

export const firstStageId = ORDERED_STAGES[0]?.id ?? "";

/**
 * The next stage in canonical order across chapters/worlds (so finishing a
 * chapter's last stage advances to the next chapter). Only the very last
 * stage of the whole campaign returns undefined.
 */
export function nextStageId(id: string): string | undefined {
  const i = ORDERED_STAGES.findIndex((s) => s.id === id);
  if (i < 0 || i + 1 >= ORDERED_STAGES.length) return undefined;
  return ORDERED_STAGES[i + 1].id;
}
